import React from "react";
import { Heading, Flex, HeaderActions } from "./style";
import SwapButton from "../components/SWAP/SwapButton";
import { Button } from "../../../components/common/Button";

type HeaderProps = {
  onViewAllWallets?: () => void;
  onCreateWallet?: () => void;
};

const Header: React.FC<HeaderProps> = ({ onViewAllWallets, onCreateWallet }) => {
  return (
    <Flex>
      <Heading>Wallet</Heading>
      <HeaderActions>
        <SwapButton />
        {onViewAllWallets && (
          <Button
            label="View all wallets"
            theme="alternate"
            height="40px"
            width="auto"
            fontSize="12px"
            onClick={onViewAllWallets}
          />
        )}
        {onCreateWallet && (
          <Button
            label="Create new wallet"
            theme="alternate"
            height="40px"
            width="auto"
            fontSize="12px"
            onClick={onCreateWallet}
          />
        )}
      </HeaderActions>
    </Flex>
  );
};
export default Header;
